import { Token } from "../api/type.d";
import { CommonTokens } from "./CommonTokens";

export default function tokenOrder(ts: Token[]): Token[] {
  return ts.sort((a, b) => {
    if (!a || !b) return 0;
    const aIndex = CommonTokens.indexOf(a.address.toLowerCase());
    const bIndex = CommonTokens.indexOf(b.address.toLowerCase());
    const aInOrderArray = aIndex !== -1;
    const bInOrderArray = bIndex !== -1;

    if (aInOrderArray && bInOrderArray) {
      // 如果两个元素都在 orderArray 中，根据它们在 orderArray 中的位置排序
      return aIndex - bIndex;
    } else if (aInOrderArray) {
      // 只有 a 在 orderArray 中
      return 1;
    } else if (bInOrderArray) {
      // 只有 b 在 orderArray 中
      return -1;
    }
    // 两个元素都不在 orderArray 中，保持原有顺序
    return 0;
  });
}
